var map = {
	"./CHeadN_s0.gif": "ytQl",
	"./CHeadN_s1.gif": "CG4y",
	"./CHeadN_s2.gif": "IAAn",
	"./CHeadN_s3.gif": "1xrB",
	"./CHeadN_s4.gif": "zCs9",
	"./CHeadN_s5.gif": "VFO0",
	"./CHeadN_s6.gif": "rPpZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mrc/";


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Arrow ^\.\/CHeadN_s.*\.gif$
// module id = mrc/
// module chunks = 44